<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _ from 'lodash'
import ListingDetail from '@/modules/realestate/views/ListingDetail.vue'
import {
  FlashOfferResultActionTypes,
  useFlashOfferResultStore
} from '@/modules/flashoffer/stores/flashoffer.result.list.store.ts'


const router = useRouter()
const flashOfferResultStore = useFlashOfferResultStore()


const pageTabs = computed(() => {
  return flashOfferResultStore.tabs
})
const displayTabContent = computed(() => {
  return flashOfferResultStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return flashOfferResultStore.tableConfig
})
const filter = computed(() => {
  return flashOfferResultStore.filter
})
const loading = computed(() => {
  return flashOfferResultStore.action_type == FlashOfferResultActionTypes.FETCHING
})
const page = computed(() => {
  return flashOfferResultStore.page
})
const pageSize = computed(() => {
  return flashOfferResultStore.pageSize
})
const dataSource = computed(() => {
  return flashOfferResultStore.data
})

const handleChangeTab = (tab: any) => {

  flashOfferResultStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  flashOfferResultStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  flashOfferResultStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  flashOfferResultStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  flashOfferResultStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  flashOfferResultStore.setFilter(filter)
}

const handleGotoDetail = (e: MouseEvent, item: any) => {

  flashOfferResultStore.newTab({id: item.id, label: `#${item.id} - ${item.subject?.title}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {

  flashOfferResultStore.toggleSort(field, direction)
}

const requestFetchFOResultList = _.debounce(async () => {
  try{
    const res = await flashOfferResultStore.fetchList()
  } catch (e) {

  }
}, 500)

watch(()=> flashOfferResultStore.uuid, (newVal, oldVal) => {
  requestFetchFOResultList()
})

onMounted(() => {
  // if(flashOfferResultStore.action_type === FlashOfferResultActionTypes.PENDING)
  requestFetchFOResultList()
})
</script>

<template>
  <dashboard-layout currentRoute="flash-offer/results" page-title="Quản lý kết quả Flash Ofer"  :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
        @reset:filter="flashOfferResultStore.resetFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"

        primaryField=""
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="flashOfferResultStore.toggleColumnVisibility"
        @on-selected-row="handleChangeSelectedRow"
        @on-sort="handleSort"

      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <ListingDetail :id="tab.id" :key="tab.id"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
